import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ResendTextMessage as ResendTextMessageMutation,
    ResendTextMessageVariables as ResendTextMessageMutationVariables,
} from 'nutshell-graphql-types';

import GET_CHANNEL_EVENTS from '../../../graphql/queries/get-channel-events.graphql';

import RESEND_TEXT_MESSAGE from '../mutations/resend-text-message.graphql';

export const useResendTextMessage = (): {
    resendTextMessage: (arg1: {
        messageId: string;
        channelId: string | null | undefined;
        threadId: string | null | undefined;
    }) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [resendTextMessage, {loading, error}] = useMutation<
        ResendTextMessageMutation,
        ResendTextMessageMutationVariables
    >(RESEND_TEXT_MESSAGE);

    return {
        resendTextMessage: (input: {
            messageId: string;
            channelId: string | null | undefined;
            threadId: string | null | undefined;
        }) => {
            const {messageId, channelId, threadId} = input;

            return resendTextMessage({
                variables: {input: {messageId}},
                update: (proxy, mutationResults) => {
                    const deletedMessage =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.textResend &&
                        mutationResults.data.textResend.message;

                    const cacheResult = proxy.readQuery({
                        query: GET_CHANNEL_EVENTS,
                        variables: {
                            channelId,
                            threadId,
                            first: 40,
                        },
                    });

                    if (cacheResult && deletedMessage) {
                        proxy.writeQuery({
                            query: GET_CHANNEL_EVENTS,
                            variables: {
                                channelId,
                                threadId,
                                first: 40,
                            },
                            data: {
                                ...cacheResult,
                                channelEvents: {
                                    // @ts-expect-error
                                    ...cacheResult.channelEvents,
                                    edges: [
                                        // The original message is now deleted so remove it from the cache
                                        // @ts-expect-error
                                        ...cacheResult.channelEvents.edges.filter(
                                            // @ts-expect-error
                                            (edge) => edge.node.payload.id !== messageId
                                        ),
                                    ],
                                },
                            },
                        });
                    }
                },
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
